import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { FieldMessage } from "../../FieldMessage/FieldMessage.mjs";
import { Stack } from "../../Stack/Stack.mjs";
import { buildDataAttributes } from "../buildDataAttributes.mjs";
import { mergeIds } from "../mergeIds.mjs";
import "../../ThemeProvider/ThemeProvider.mjs";
import "../../ThemePortal/ThemePortal.mjs";
import "../../Text/TextContext.mjs";
import "../../ThemeProvider/ThemeContext.mjs";
import "../../ThemeProvider/VanillaThemeContainer.mjs";
import "../DefaultMessagesContext.mjs";
import "../../ThemeProvider/BreakpointContext.mjs";
import "../../../css/atoms/sprinkles.css.mjs";
import "../../Box/BackgroundContext.mjs";
import "../../Divider/Divider.css.mjs";
import "../../Accordion/AccordionContext.mjs";
import { Text } from "../../Text/Text.mjs";
import "../../../css/negativeMargin/negativeMargin.css.mjs";
import "../../Columns/ColumnsContext.mjs";
import "../../Column/Column.css.mjs";
import "../../Heading/HeadingContext.mjs";
import "../../../css/lineHeightContainer.css.mjs";
import "../../../css/reset/reset.css.mjs";
import "../../../hooks/useIcon/icon.css.mjs";
import "../../../css/typography.css.mjs";
import "../touchable/virtualTouchable.css.mjs";
import "../hideFocusRings/hideFocusRings.css.mjs";
import "../../Accordion/AccordionItem.css.mjs";
import "../../Actions/ActionsContext.mjs";
import "../../../css/textAlignedToIcon.css.mjs";
import "../../Alert/Alert.css.mjs";
import "../../Autosuggest/Autosuggest.mjs";
import "../../Avatar/Avatar.css.mjs";
import "../../Badge/Badge.mjs";
import "../../Breadcrumb/Breadcrumb.css.mjs";
import "../../Box/ColoredBox.mjs";
import "../../Button/Button.mjs";
import "../../ButtonIcon/ButtonIcon.mjs";
import "../../ButtonLink/ButtonLink.mjs";
import "../Keyline/Keyline.css.mjs";
import "../../Checkbox/Checkbox.mjs";
import "../../Checkbox/CheckboxStandalone.mjs";
import "../../ContentBlock/ContentBlock.css.mjs";
import "../../DateField/DateField.mjs";
import "../Field/FloatingLabel.css.mjs";
import "../Field/Field.css.mjs";
import "../../DateField/DateField.css.mjs";
import "../Modal/Modal.mjs";
import "../Modal/ModalContent.mjs";
import "../Modal/ModalContext.mjs";
import "../../TextLink/TextLink.mjs";
import "../../TextLinkButton/TextLinkButton.css.mjs";
import "../AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../../Dropdown/Dropdown.mjs";
import "../MaxLines/MaxLines.css.mjs";
import "../../Hidden/Hidden.css.mjs";
import "../../HiddenVisually/HiddenVisually.css.mjs";
import "../../Link/Link.mjs";
import "../defaultTextProps.mjs";
import "../../List/List.css.mjs";
import "../../Loader/Loader.css.mjs";
import "../../Skeleton/Skeleton.css.mjs";
import "../../MenuRenderer/MenuRenderer.mjs";
import "../../MenuItem/MenuItem.mjs";
import "../../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../../MenuItemDivider/MenuItemDivider.mjs";
import "../../MenuItem/MenuItemLink.mjs";
import "../../OverflowMenu/OverflowMenu.css.mjs";
import "../../MonthPicker/MonthPicker.mjs";
import "../../Pagination/Pagination.css.mjs";
import "../../PasswordField/PasswordField.mjs";
import "../../Pincode/Pincode.mjs";
import "../../PopoverRenderer/PopoverRenderer.mjs";
import "../../Pressable/Pressable.mjs";
import "../../RadioGroup/RadioGroup.mjs";
import "../../RadioGroup/RadioItem.mjs";
import "../../RadioGroup/RadioItemBlock.mjs";
import "../../SelectableList/SelectableList.css.mjs";
import "../BulkActions/BulkActions.css.mjs";
import "../../Spread/Spread.css.mjs";
import "../../Stepper/Step.mjs";
import "../../Stepper/Stepper.mjs";
import { Strong } from "../../Strong/Strong.mjs";
import "../../Tabs/Tab.mjs";
import "../../Table/Table.mjs";
import "../../Table/Table.css.mjs";
import "../../Tabs/TabsProvider.mjs";
import "../../Tabs/TabListContext.mjs";
import "../../Tabs/Tabs.css.mjs";
import "../../Tabs/TabPanelsContext.mjs";
import "../../Tag/Tag.css.mjs";
import "../../Textarea/Textarea.mjs";
import "../../TextDropdown/TextDropdown.css.mjs";
import "../../TextField/TextField.mjs";
import "../../Tiles/Tiles.css.mjs";
import "../../Toggle/Toggle.mjs";
import "../../useToast/ToastContext.mjs";
import "../../TooltipRenderer/TooltipRenderer.mjs";
import "../../TimeField/DateSegment.css.mjs";
import "../FieldButtonIcon/FieldButtonIcon.mjs";
import "../../MultiStepModal/MultiStepModal.mjs";
import "../../SearchField/SearchField.mjs";
import "../../RadioBar/RadioBarContext.mjs";
import "../../RadioBar/RadioBar.css.mjs";
import "../../../themes/vars.css.mjs";
import "../../RadioBar/RadioBar.mjs";
const FieldGroup = ({
  id,
  disabled,
  children,
  message,
  reserveMessageSpace = false,
  tone,
  required,
  role,
  space = "xsmall",
  data,
  ...restProps
}) => {
  const labelId = `${id}-label`;
  const messageId = `${id}-message`;
  let ariaLabelledBy;
  let ariaLabel;
  if ("label" in restProps && restProps.label) {
    ariaLabelledBy = labelId;
  } else if ("aria-labelledby" in restProps && restProps["aria-labelledby"]) {
    ariaLabelledBy = restProps["aria-labelledby"];
  } else if ("aria-label" in restProps && restProps["aria-label"]) {
    ariaLabel = restProps["aria-label"];
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "fieldset",
      disabled,
      id,
      role,
      "aria-labelledby": ariaLabelledBy,
      "aria-label": ariaLabel,
      "aria-required": required,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsxs(Stack, { space, children: [
        "label" in restProps && restProps.label ? /* @__PURE__ */ jsx(Box, { component: "legend", id: labelId, children: /* @__PURE__ */ jsx("label", { id: labelId, children: /* @__PURE__ */ jsx(Text, { tone: disabled ? "secondary" : void 0, children: /* @__PURE__ */ jsx(Strong, { children: restProps.label }) }) }) }) : null,
        children({
          disabled,
          "aria-describedby": mergeIds(message ? messageId : void 0)
        }),
        message || reserveMessageSpace ? /* @__PURE__ */ jsx(
          FieldMessage,
          {
            id: messageId,
            tone,
            disabled,
            message,
            reserveMessageSpace
          }
        ) : null
      ] })
    }
  );
};
export {
  FieldGroup
};
